<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="left">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :errors.sync="errors" :form.sync="form"
               :edit-mode="editMode"
      >
        <el-form-item label="账号" required prop="username">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="姓名" required prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="所属系统" prop="system_type">
          <el-select v-model="form.system_type" placeholder="选择所属系统" clearable>
            <el-option v-for="i of systemTypeOptions" :key="i.value" :label="i.title" :value="i.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="管理仓库" v-show="isStock" required prop="warehouses">
          <el-select v-model="form.warehouses" clearable filterable multiple placeholder="请选择所属仓库">
            <el-option v-for="item in warehouseList" :key="item.code" :label="item.name" :value="item.code">
              <template v-if="item.code != '*'">
                <span style="float: left">
                  {{ item.name }}
                  <span v-if="item.is_default == 1" style="color:coral">[默认]</span>
                </span>
                <span v-if="item.area" style="float: right; color: #8492a6; font-size: 13px">
                  {{ item.area + '/' + item.address }}
                </span>
              </template>
              <template v-else>
                <span>  **** {{ item.name }} ****</span>
              </template>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="头像" prop="avatar">
          <file-picker v-model="form.avatar" ext="jpg,gif,png,jpeg" />
        </el-form-item>
        <el-form-item label="密码" :required="!editMode" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="确认密码" :required="!editMode" prop="password_confirmation">
          <el-input v-model="form.password_confirmation" type="password" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="角色" prop="roles">
          <el-select v-model="form.roles" multiple placeholder="选择角色" filterable clearable>
            <el-option v-for="i of roles" :key="i.id" :label="i.name" :value="i.id" />
          </el-select>
        </el-form-item>
        <!--  <el-form-item label="权限" prop="permissions">
          <el-select v-model="form.permissions" multiple placeholder="选择权限" filterable clearable >
            <el-option v-for="i of permissions" :key="i.id" :label="i.name" :value="i.id" />
          </el-select>
        </el-form-item>-->
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { createAdminUser, editAdminUser, storeAdminUser, updateAdminUser } from '@/api/admin-users'
import FilePicker from '@c/FilePicker'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'

const systemTypes = [
  {
    title: '运营后台',
    value: 0,
  },
  {
    title: '发货中心',
    value: 1,
  },
  {
    title: '仓库中心',
    value: 2,
  },
]
export default {
  name: 'Form',
  components: {
    FilePicker,
    LzForm,
  },
  mixins: [FormHelper],
  data() {
    return {
      systemTypeOptions: systemTypes,
      form: {
        username: '',
        name: '',
        system_type: 0,
        password: '',
        password_confirmation: '',
        roles: [],
        permissions: [],
        avatar: '',
        warehouses: [],
      },

      isStock: false,
      oldWarehouses: [],
      errors: {},
      roles: [],
      permissions: [],
      warehouseList: [],
    }
  },
  watch: {
    'form.system_type': {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (newVal == 2) {
          this.isStock = true
          this.form.warehouses = JSON.parse(JSON.stringify(this.oldWarehouses))
        } else {
          this.isStock = false
          this.form.warehouses = ['*']
        }
      },
    },
  },
  methods: {
    async onSubmit() {
      if (this.editMode) {
        await updateAdminUser(this.resourceId, this.form)
      } else {
        await storeAdminUser(this.form)
      }
    },
    async getData() {
      let data

      if (this.editMode) {
        ;({ data } = await editAdminUser(this.resourceId))
        this.fillForm(data.admin_user)
      } else {
        ;({ data } = await createAdminUser())
      }

      this.roles = data.roles
      this.permissions = data.permissions
      this.warehouseList = data.warehouses
      // 备份原有
      if (data.admin_user && data.admin_user.warehouses) {
        this.oldWarehouses = JSON.parse(JSON.stringify(data.admin_user.warehouses))
      } else {
        this.oldWarehouses = ['*']
      }
    },
  },
}
</script>
